<template>
  <div class="anim-number">
    {{ animatedNumber }}
  </div>
</template>

<script>
import gsap from "gsap";
import animMixin from "@/assets/js/animMixin.js";
export default {
  name: "animNumber",
  mixins: [animMixin],
  props: {
    dataNumber: Number,
    map: Array
  },

  data() {
    return {
      number: 0,
      tweenedNumber: 0
    };
  },

  computed: {
    animatedNumber() {

      if (this.rawArr.length > 0) {
        return this.p5map(
          this.tweenedNumber,
          this.rawArr[0],
          this.rawArr[1],
          this.rawArr[2],
          this.rawArr[3]
        ).toFixed(0);
      }
      else {
         return this.tweenedNumber.toFixed(0);
      }
    },

    rawNumber() {
      return this.dataNumber;
    },
    rawArr(){
        return this.map !== undefined ? this.map : [];
    }
  },

  watch: {
    dataNumber(nv) {
      gsap.to(this.$data, { duration: 0.5, tweenedNumber: nv });
    }
  }
};
</script>

<style></style>
